import { render } from "./AppField.vue?vue&type=template&id=4db901a2&scoped=true"
const script = {}

import "./AppField.vue?vue&type=style&index=0&id=4db901a2&scoped=true&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4db901a2"]])

export default __exports__